import React, { useState } from "react";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function Geofence() {
    const [selectedParameter, setSelectedParameter] = useState(null);
    const [searchText, setSearchText] = useState("");

    const vehicleOptions = [...Array(10).keys()].map((i) => ({
        value: `KA0${i + 1}AB1234`,
        label: `KA0${i + 1}AB1234`,
    }));
    const data = [
        { id: 1, date: "2024-02-20", vehicleNo: "KA01AB1234", timeOut: "09:30", parkingDuration: "15 min", geofence: "Main Gate", durationIn: "30 min", timeIn: "09:00" },
        { id: 2, date: "2024-02-21", vehicleNo: "MH12CD5678", timeOut: "10:45", parkingDuration: "10 min", geofence: "Warehouse", durationIn: "45 min", timeIn: "10:00" },
        { id: 3, date: "2024-02-22", vehicleNo: "DL05EF9012", timeOut: "08:20", parkingDuration: "20 min", geofence: "Office Parking", durationIn: "1 hr", timeIn: "07:00" },
        { id: 4, date: "2024-02-23", vehicleNo: "TN09GH3456", timeOut: "07:50", parkingDuration: "25 min", geofence: "Factory Entrance", durationIn: "50 min", timeIn: "07:00" },
        { id: 5, date: "2024-02-24", vehicleNo: "AP16IJ7890", timeOut: "11:30", parkingDuration: "12 min", geofence: "Mall Parking", durationIn: "35 min", timeIn: "11:00" },
        { id: 6, date: "2024-02-25", vehicleNo: "GJ18KL2345", timeOut: "06:40", parkingDuration: "30 min", geofence: "Residential Gate", durationIn: "40 min", timeIn: "06:00" },
        { id: 7, date: "2024-02-26", vehicleNo: "RJ20MN6789", timeOut: "12:15", parkingDuration: "18 min", geofence: "Gas Station", durationIn: "25 min", timeIn: "11:45" },
        { id: 8, date: "2024-02-27", vehicleNo: "UP22OP1234", timeOut: "13:10", parkingDuration: "22 min", geofence: "Hospital Entry", durationIn: "55 min", timeIn: "12:15" },
    ];

    const columns = [
        { name: "S.No", selector: (row) => row.id, sortable: true },
        { name: "Date", selector: (row) => row.date, sortable: true },
        { name: "Vehicle Number", selector: (row) => row.vehicleNo, sortable: true },
        { name: "Time Out", selector: (row) => row.timeOut, sortable: true },
        { name: "Parking Duration", selector: (row) => row.parkingDuration, sortable: true },
        { name: "Geofence Name", selector: (row) => row.geofence, sortable: true },
        { name: "Duration In", selector: (row) => row.durationIn, sortable: true },
        { name: "Time In", selector: (row) => row.timeIn, sortable: true },
    ];

     const handleExportPDF = () => {
        const doc = new jsPDF();
        autoTable(doc, {
            head: [columns.map((col) => col.name)],
            body: filteredData.map((row) => columns.map((col) => row[col.selector ? col.selector(row) : row[col.name]])),
        });
        doc.save("trips-data.pdf");
    };
    const customStyles = {
        headCells: {
            style: {
                backgroundColor: "#888888 ",
                color: "#ffffff",
                fontWeight: "bold",
            },
        },
    };
    const filteredData = data.filter((row) =>
        Object.values(row).some((val) =>
            val.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Geofence </h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a href="#/">Dashboard</a></li>
                                <li className="breadcrumb-item active">Geofence</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header p-1 pt-2">
                            <div className="row mb-3 d-flex justify-content-center">
                                <div className="col-sm-12 col-md-12 col-lg-3 mb-1">
                                    <label>Select Vehicle</label>
                                    <Select
                                        options={vehicleOptions}
                                        value={selectedParameter}
                                        onChange={setSelectedParameter}
                                        isSearchable={true} // Enables search
                                        placeholder="Select Vehicle"
                                        className="basic-single"
                                        classNamePrefix="select"
                                    />
                                </div>

                                <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                    <label>From</label>
                                    <input type="date" className="form-control" />
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                    <label>To</label>
                                    <input type="date" className="form-control" />
                                </div>
                                <div className="col-md-1 mt-4">
                                    <input type="submit" value="Search" className="mt-1 btn btn-primary waves-effect waves-light" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-3">
                                <div>
                                    <CSVLink data={filteredData} filename="trips-data.csv" className="btn btn-primary btn-sm me-2">
                                        Export to CSV
                                    </CSVLink>
                                    <button onClick={handleExportPDF} className="btn btn-danger btn-sm">
                                        Export to PDF
                                    </button>
                                </div>
                                <div className="col-lg-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                </div>
                            </div>
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                pagination
                                highlightOnHover
                                responsive
                                customStyles={customStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
